import { AtImage, AtImageProps } from '../../atoms/at-image'
import { getAtImageVariant } from '../../atoms/at-image/at-image.props'
import { Media, OrMedia } from '../../organisms'

export interface MlBannerLogoProps {
  name?: string
  media?: Media
  logo?: AtImageProps
}

export const MlBannerLogo = ({ media, logo }: MlBannerLogoProps) => {
  const hasMedia = Boolean(media && media.src)
  const hasLogo = Boolean(logo && logo.src)

  if (!hasMedia && !hasLogo) return null

  return (
    <div className="flex relative flex-col items-center justify-center md:h-170 h-128 w-auto">
      {media && <OrMedia {...media} className={getAtImageVariant('background')} />}
      <div className="absolute inset-0 bg-neutrals-black/[.3]"></div>
      {hasLogo && (
        <div className="md:h-57.5 h-24.25">
          <AtImage variant="banner-logo" {...logo} />
        </div>
      )}
    </div>
  )
}
